import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from './auth-state.service';

export const adminOnlyGuard: CanActivateFn = () => {
  const authStateService = inject(AuthStateService);
  const router = inject(Router);
  const user = authStateService.user();

  if (user?.isCustomerPortalAdmin) {
    return true;
  }

  return router.parseUrl('/dashboard');
};
